import { collection, doc, setDoc, getDocs, query, where, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

const COMMENTS = "comments";

export async function addComment(comment) {
  const ref = doc(collection(db, COMMENTS));
  // Use Firestore serverTimestamp (authoritative), not the browser clock.
  await setDoc(ref, { id: ref.id, ...comment, createdAt: serverTimestamp() });
  return ref.id;
}

export async function listComments(caseId, designerId) {
  // No designer selected yet -> there is no private conversation.
  if (!designerId) return [];
  // Filter by designerId IN THE QUERY (not client-side): otherwise Firestore evaluates
  // the read rule against docs from a previous designer / legacy docs and rejects the
  // whole query with permission-denied. Scoping the query keeps every returned doc valid.
  const q = query(
    collection(db, COMMENTS),
    where("caseId", "==", caseId),
    where("designerId", "==", designerId)
  );
  const snap = await getDocs(q);
  return snap.docs
    .map((d) => {
      const data = d.data();
      return { id: d.id, ...data, _ts: data.createdAt?.toMillis?.() ?? null };
    })
    .sort((a, b) => (a._ts ?? 0) - (b._ts ?? 0));
}
